/*
 * Module for the Available Work Monitor job criteria page
 */
rs.module("content/jobs/criteria/availableworkmonitor", [],

    function () {

        // Initialize the page
        function initialize(jsSelectors) {

            var criteria = $.js(jsSelectors.criteria);

            var lastDaysCheckBox = criteria.js(jsSelectors.lastDaysCheckBox);
            var daysOldCheckBox = criteria.js(jsSelectors.daysOldCheckBox);
            var lastDaysTextBox = criteria.js(jsSelectors.lastDaysTextBox);
            var daysOldTextBox = criteria.js(jsSelectors.daysOldTextBox);

            //enable/disable the LastDays and DaysOld text boxes on Load
            enableDisableDaysOld();
            enableDisableLastDays();

            // register lastDaysCheckBox change event 
            lastDaysCheckBox.change(function () {
                enableDisableLastDays();
            });

            // register daysOldCheckBox change event 
            daysOldCheckBox.change(function () {
                enableDisableDaysOld();
            });  

            // enable/disable the LastDays text box based on the LastDays check box
            function enableDisableLastDays() {
                if (lastDaysCheckBox.is(":checked")) {
                    lastDaysTextBox.prop('disabled', false);
                }
                else {
                    lastDaysTextBox.prop('disabled', true);
                    lastDaysTextBox.val("");
                }
            };

            //enable/disable the DaysOld text box based on the DaysOld check box
            function enableDisableDaysOld() {
                if (daysOldCheckBox.is(":checked")) {
                    daysOldTextBox.prop('disabled', false);
                }
                else {
                    daysOldTextBox.prop('disabled', true);
                    daysOldTextBox.val("");
                }
            }
        }
    
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);